import { createAsyncAction } from '../helpers';

export const postGetListAsyncAction = createAsyncAction('POSTS_GET');

export const postGetDetailAsyncAction = createAsyncAction('POST_GET_DETAIL');
